import React, { useState } from 'react';
import ClientLogin from './client/ClientLogin';
import VendorLogin from './vendor/VendorLogin';
import ResetPassword from './ResetPassword';
import { Alert } from '@mui/material';
import 'src/css/Login.css';
import splashLow from '../images/corpay-splash-low.png';
import splashMed from '../images/corpay-splash-med.png';
import splashHigh from '../images/corpay-splash-high.png';
import splashXL from '../images/corpay-splash-xl.png';
import { useLocation } from 'react-router-dom';

const Login = () => {
	const location = useLocation();
	const [activeSite, setActiveSite] = useState(location.state?.activeSite ?? 'CLIENT');
	const [forgotPassword, setForgotPassword] = useState(false);
	const [error, setError] = useState('');	
	const [hasToken, setHasToken] = useState(false);
	
	const showError = (err) =>
		(typeof err === 'object' ? err.message : err );

	return (			
		<div className="container" style={{overflow:"hidden"}}>
			<table className="flexTable" style={{border:"none"}} border="0" width="100%" height="100vh" cellPadding="10" cellSpacing="0">
				<tbody style={{display:"table", width:"100%", border:"none"}}>		
					<tr>
						<td style={{minWidth:"50px"}}>&nbsp;</td>
						<td width="450px" valign="center">
							<img src={ require("../images/corpay-clientvendor.jpg") } alt="Corpay Invoice Automation Solutions" style={{marginBottom:20}} />

							{ !error && <div style={{height:48, marginBottom:10}}></div> }
							{ error && <Alert severity="error" style={{marginBottom:10}}>{showError(error)}</Alert> }

							<div id="loginWrapper" style={{ position:"relative", width:"475px" }}>
								<div id="btnBorder">
									<button disabled={hasToken} className={`loginBtns ${activeSite == 'CLIENT' ? "selectedBtn" : ""}`} id="clientForm" onClick={() => {setError(); setActiveSite('CLIENT');}}>CLIENT LOGIN</button>
									<button disabled={hasToken} className={`loginBtns ${activeSite == 'VENDOR' ? "selectedBtn" : ""}`} id="vendorForm" onClick={() => {setError(); setActiveSite('VENDOR');}}>VENDOR LOGIN</button>
								</div>
								
								{!forgotPassword && activeSite === 'CLIENT' && <ClientLogin onLoginError={setError} setHasToken={setHasToken}/>}
								{!forgotPassword && activeSite === 'VENDOR' && <VendorLogin onLoginError={setError} setHasToken={setHasToken}/>}
								
								{forgotPassword && <ResetPassword activeSite={activeSite} onReset={() => setForgotPassword(false)}/>}
								
								{!forgotPassword &&
								<a href="#" onClick={(e) => setForgotPassword(true)} className="loginTrouble" style={{float:"right", marginRight:"15px", marginBottom:"20px", fontSize:"10pt", color:"#981239"}}>Reset Password</a>}
								<br/><br/>
								<p style={{fontSize: "9pt"}}>Still having trouble? Please contact us: 1-800-682-2187 or (UK) 020-739-85700 or email info@ias.corpay.com</p>
							</div>
							
						</td>
						<td style={{minWidth:"50px"}}>&nbsp;</td>
						<td width="100%" rowSpan="2" style={{backgroundColor:'#230C18', textAlign:'center', padding:'10vh'}}>
						<img srcSet={`${splashLow} 800w, ${splashMed} 1600w, ${splashHigh} 2400w, ${splashXL} 3200w`} src={splashMed} style={{ height:'80vh', filter:"grayscale(0.5)" }} /></td>
					</tr>
					<tr>
						<td colSpan="3" style={{height:"70px", backgroundColor:"#E6E8E7", textAlign:"center"}}>						
							<span style={{fontSize:"14pt"}}>Corpay<span style={{color:"#981239"}}>^</span></span> 
							<span style={{fontSize:"8pt"}}>&copy; Cambridge Mercantile Corp. All rights reserved.</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>					
	);
};

export default Login;